import { mockFormOverrideAddress } from '@domgen/dgx-fe-forms/address';
import { ApplianceDetailsSteppedFormValue } from '../../models/appliance-details-stepped/appliance-details-stepped-form-value.type';

export const mockApplianceDetailsSteppedFormValue: ApplianceDetailsSteppedFormValue =
  {
    applianceCategoryCode: 'WM',
    applianceCode: 'CN',
    brandCode: 'AEG',
    modelAndSerialNumber: {
      modelNumber: null,
      serialNumber: null,
    },
    purchasePrice: '123',
    purchaseDate: new Date(
      'Wed Nov 06 2024 00:00:00 GMT+0000 (Greenwich Mean Time)'
    ),
    personalDetails: {
      address: mockFormOverrideAddress,
      firstName: '',
      lastName: '',
      emailAddress: '',
      telephoneNumber: '45435345',
      privacyPolicy: false,
    },
  };
